export class AuthModal {
    init () {
        let modalHandler = function (modalId) {
            let modal = getModal(modalId);
            let form = modal.find('form');
            let submitButton = modal.find('button[form]');

            form.submit((event) => {
                event.preventDefault();

                if (modalId !== 'registerModal') {
                    return ajaxCall(form, modalId);
                }

                if (typeof grecaptcha === 'object') {
                    let formId = form.attr('id');

                    return grecaptcha
                        .execute($('[data-rekey]').data('rekey'), { action: formId })
                        .then((response) => ajaxCall(form, modalId, { g_response: response, g_action: formId }));
                }

                return ajaxCall(form, modalId);
            })
        }

        let getModal = function (modalId) {
            let modalSelector = '.modal.login-modals#' + modalId;

            return $(modalSelector);
        }

        let ajaxCall = function (form, modalId, appendData) {
            let modal = getModal(modalId);
            let formData = form.serializeArray();
            let url = form.attr('action');
            let redirectUrl = formData.find(x => x.name === "redirect_url");
            redirectUrl = redirectUrl ? redirectUrl.value : null;

            if (appendData) {
                $.each(appendData, function (key, obj) {
                    formData.push({ name: key, value: obj});
                });
            }

            $.ajax({
                type: "POST",
                url,
                data: formData
            }).success((data) => {
                if (modalId == 'loginModal') {
                    if (redirectUrl && typeof redirectUrl !== 'undefined' && redirectUrl !== null && redirectUrl !== '') {
                        window.location = redirectUrl;
                        return;
                    }

                    window.location = window.location;
                } else if (modalId == 'registerModal') {
                    let modalHeader = modal.find('.modal-header'),
                        modalBody = modal.find('.modal-body');

                    form.fadeOut(function () {
                        modal.find('.modal-footer').fadeOut();
                        modalHeader.addClass('justify-content-center').html('<h4 class="modal-title" id="registerModalLabel">Please check your inbox</h4>');
                        modalBody.find('.message')
                            .removeClass('d-none')
                            .html('An e-mail with instructions <br>will be sent to you.');
                        modalBody.find('.register-confirmed')
                            .removeClass('d-none')
                    })
                } else if (modalId == 'resetModal') {
                    modal.find('.reset-info').fadeOut();
                    form.fadeOut(function () {
                        modal.find('.reset-message').html(data.result).fadeIn();
                    })
                    modal.find('.modal-footer').fadeOut();
                }
            }).error((data) => {
                let errorField = form.find('.form-field--error'),
                    errorMsg = JSON.parse(data.responseText);

                if (data.status == 405 || data.status == 503) {
                    errorField.html(errorMsg.error.message);
                    errorField.show();
                    return;
                }

                if (modalId == 'loginModal') {
                    errorField.html('Login or/and password incorrect, please try again.');
                    errorField.show();
                    return;
                }

                if (modalId == 'registerModal' && data.status == 409) {
                    errorField.html(errorMsg.error.message);
                } else if (modalId == 'registerModal' && data.status == 400) {
                    let replaced = errorMsg.error.message.replaceAll('_', ' ');
                    errorField.html(replaced);
                } else if (modalId == 'resetModal' && data.status == 400) {
                    modal.find('.reset-message').html(errorMsg.error.message).fadeIn();
                }

                errorField.show();
            })
        }

        modalHandler('loginModal');
        modalHandler('registerModal');
        modalHandler('resetModal');
    }
}